/*
 |--------------------------------------------------------------------------
 | memoize Promise
 |--------------------------------------------------------------------------
 */


import { toArray } from 'lodash';

export default function memoizePromise(fn) {
	// Since a function is nothing more than an object
	// we create a property with an object on it
	fn.memoizeCache = {};

	// Lets return a new function
	return function memoized() {
		const
			cache = fn.memoizeCache,
			args = toArray(arguments),
			stringParams = JSON.stringify(args).trim();

		if (cache[stringParams]) {
			return cache[stringParams];
		}

		const promise = fn.apply(this, args);

		fn.memoizeCache[stringParams] = promise;

		// If the call fails, make sure we remove it from the cache
		promise.catch(() => delete fn.memoizeCache[stringParams]);

		return promise;
	};
}
